import styled, { css } from 'styled-components';
import Box from '@nubank/nuds-web/components/Box/Box';
import { breakpointsMedia } from '@nubank/nuds-web/styles/breakpoints';
import { nuDSColor, spacing } from '@nubank/nuds-web/styles/themeUtils';

export const StyledNavbar = styled(Box)`
  position: sticky;
  white-space: pre;
  color: white;
  scroll-behavior: smooth;
  text-align: center;
  width: 100%;
  transform: translate3d(0, 100%, 0);
  transition: transform ease-out 300ms;
  will-change: transform;
  bottom: 0;
  padding: ${spacing('4x')} ${spacing('8x')} calc(env(safe-area-inset-bottom) + ${spacing('4x')});
  background-color: ${nuDSColor('black', 'default')};
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;

  ${breakpointsMedia({
    xs: css`
      overflow-x: auto;
    `,

    lg: css`
      overflow: hidden;
    `,
  })}

  &.visible {
    transform: translate3d(0, 0, 0);
  }

  & .selected {
    position: relative;
  }

  & .selected::after {
    content: '';
    position: absolute;
    background-color: white;
    width: 4px;
    height: 4px;
    border-radius: 4px;
    top: calc(100% + 2px);
    left: 50%;
    transform: translateX(-50%);
  }
`;

StyledNavbar.displayName = 'StyledNavbar';
